import React, {Component} from 'react';

class FJLeftWaveIcon extends Component {
    render() {
        return (
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                 viewBox="0 0 204 599">
                <g>
                    <path fill='#F8F8F8' d="M106.8,364.4c8.3,0,15-6.7,15-15c0-8.3-6.7-15-15-15H37.5c-5.2,0-9.4-4.2-9.4-9.4c0-5.2,4.2-9.4,9.4-9.4h21.2
		c7.6,0,13.8-5.6,14.8-12.9c0.5-1.4,0.7-2.9,0.7-4.5c0-8-6.5-14.6-14.6-14.6l-56.7,0c-1,0-2-0.2-3-0.5V294v10.4v60.2
		c0.6-0.1,1.3-0.2,1.9-0.2L106.8,364.4z"/>
                    <path fill='#F8F8F8' d="M180.8,529.2H28.2c-5.2,0-9.4-4.2-9.4-9.4s4.2-9.4,9.4-9.4h28.6c8.3,0,15-6.7,15-15c0-8.3,6.7-15,15-15h40.9
		c5.2,0,9.4-4.2,9.4-9.4c0-5.2-4.2-9.4-9.4-9.4h-55c-8.3,0-15-6.7-15-15s-6.7-15-15-15h-5.6c-5.2,0-9.4-4.2-9.4-9.4
		c0-5.2,4.2-9.4,9.4-9.4h42.6c8.3,0,15-6.7,15-15c0-8.3-6.7-15-15-15H1.9c-0.7,0-1.3-0.1-1.9-0.2v216h117c0.9-1.9,1.3-4,1.3-6.2
		c0-8.3-6.7-15-15-15H47.2c-5.2,0-9.4-4.2-9.4-9.4c0-5.2,4.2-9.4,9.4-9.4h133.6c8.3,0,15-6.7,15-15
		C195.8,535.9,189.1,529.2,180.8,529.2z"/>
                    <path fill='#F8F8F8' d="M201.6,0H0v0v265.6c1-0.3,2-0.5,3-0.5h134c8.3,0,15-6.7,15-15c0-8.3-6.7-15-15-15H79.2c-5.2,0-9.5-4.3-9.5-9.5
		c0-5.1-4.1-9.2-9.2-9.2H55c-8.3,0-15-6.7-15-15c0-8.3,6.7-15,15-15h36.8c5.2,0,9.4-4.2,9.4-9.4c0-5.2,4.2-9.4,9.4-9.4h34.5
		c8.3,0,15-6.7,15-15v0c0-8.3-6.7-15-15-15H22.1c-5.2,0-9.4-4.2-9.4-9.4c0-5.2,4.2-9.4,9.4-9.4h21.7c8.3,0,15-6.7,15-15
		c0-8.3,6.7-15,15-15h7.1c5.2,0,9.4-4.2,9.4-9.4c0-5.2,4.2-9.4,9.4-9.4h38.1c8.3,0,15-6.7,15-15s-6.7-15-15-15h-95
		c-5.2,0-9.4-4.2-9.4-9.4c0-5.2,4.2-9.4,9.4-9.4h145.6c8.3,0,15-6.7,15-15C203.3,4.3,202.7,2,201.6,0z"/>
                </g>
            </svg>
        );
    }
}

export default FJLeftWaveIcon;